const anchor = [...document.querySelectorAll('.tabs-nav__button-link')];
const sectionContent = document.querySelector('.job-details__slides');
const activeClass = 'is-active';
const root = document.documentElement;

if(anchor) {
    let buttons = anchor.length;
    if(buttons > 4) {
        buttons = buttons / 2; 
    }
    root.style.setProperty('--nav-columns', buttons);
}

function handleWindowResize() {
    if (window.innerWidth < 992) {
        sectionContent.style.transform = 'translateX(0)';
    }
}

if(sectionContent) {

    //Set CSS Variable --slide-columns to create slides grid,
    let items = document.querySelectorAll('.job-detail-slide').length;
    root.style.setProperty('--slide-columns', items);

    //Event for the section to slide on click.
    document.querySelector('.tabs-nav__list').addEventListener('click', (e) => {
        const { target } = e;
    
        if (target.classList.contains('tabs-nav__button-link')) {
            const index = anchor.indexOf(target);
    
            const translationPercentage = index * 100;
    
            sectionContent.style.transform = `translateX(-${translationPercentage}%)`;
    
            const previousActiveButton = document.querySelector(`.${activeClass}`);
            if (previousActiveButton) {
                previousActiveButton.classList.remove(activeClass);
            }
    
            target.parentNode.classList.add(activeClass);
        }
    });

    window.addEventListener('resize',handleWindowResize);
}


